import React from "react"

import * as S from "./the-buzz-blog-posts.styles"
import Container from "@mui/material/Container"
import CustomImage from "../../components/custom-image/custom-image.component"
import moment from "moment"

import Grid from "@mui/material/Grid"

const TheBuzzBlogPosts = ({ blogs }) => {
  const parse = require("html-react-parser")

  return (
    <S.Background>
      <Container maxWidth="lg">
        <S.Columns container spacing={8}>
          {blogs.map((item, index) => (
            <Grid item key={index} xs={12} sm={6}>
              <S.Wrapper
                url={
                  item.blog.postFields.url
                    ? item.blog.postFields.url
                    : `/the-buzz${item.blog.uri}`
                }
                target={item.blog.postFields.url ? "_blank" : ""}
              >
                {item.blog?.featuredImage?.node && (
                  <div className="wrapper">
                    <CustomImage img={item.blog.featuredImage.node} />
                  </div>
                )}
                <div>
                  {item.blog?.title && (
                    <h2 className="title">{item.blog.title}</h2>
                  )}
                  {item.blog?.excerpt && (
                    <p className="text">{parse(item.blog.excerpt)}</p>
                  )}
                  {item.blog?.date && (
                    <p className="date">
                      {moment(item.blog.date).format("MMM DD, YYYY")}
                    </p>
                  )}
                </div>
              </S.Wrapper>
            </Grid>
          ))}
        </S.Columns>
      </Container>
    </S.Background>
  )
}

export default TheBuzzBlogPosts
